import React from 'react';
import { Grid } from 'semantic-ui-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, STATUS_TYPES, SearchBar, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from 'dyl-components';

import './PermissionsHeader.scss'
import RestrictedView from 'shared/RestrictedView';

export const PermissionsHeader = ({ isReadingRoles, isReadingUserProductLimts }) => {
    const navigate = useNavigate();
    const [ query ] = useSearchParams();
    const search = query.get('search') || '';

    const searchFunction = (value)=> navigate(`/settings/permission-profile?search=${value}`);
    const cancelFunction = ()=> navigate(`/settings/permission-profile`);

    return (
        <Grid className='Permissions__New'>
            <Grid.Row verticalAlign='middle'>
                <Grid.Column width='6' floated='left'>
                    <SearchBar
                        isSearching={ isReadingRoles }
                        search={ search }
                        searchFcn={ searchFunction }
                        cancelFcn={ cancelFunction }
                        placeholder={ 'Search for a Permission Role'}
                    />
                </Grid.Column>
                <Grid.Column width={6} floated='right' textAlign='right'>
                    <RestrictedView type="disabled" productPermission={PRODUCT_PERMISSIONS.SETTINGS_PERMISSION_PROFILE} userPermission={USER_PERMISSIONS.PERMISSIONS_ADD}>
                            <Button disabled={isReadingUserProductLimts} status={STATUS_TYPES.PRIMARY} onClick={() => navigate('/settings/add-permission-profile')}>
                                + New Permission Profile
                            </Button>
                    </RestrictedView>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}